import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 md:py-8 px-4 bg-brand-dark border-y border-white/5" data-id="element-87">
      <div className="max-w-md mx-auto text-center" data-id="element-88">
        <div className="inline-flex items-center justify-center w-14 h-14 bg-brand-accent/10 border border-brand-accent/30 rounded-2xl mb-4" data-id="element-89">
          <ShieldCheck className="w-7 h-7 text-brand-accent" data-id="element-90" />
        </div>

        <h2 className="text-xl md:text-2xl font-extrabold mb-1 text-white leading-tight" data-id="element-91">
          🛡️ Garantía 7 días
        </h2>
        <p className="text-sm md:text-base font-semibold text-brand-accent mb-3 uppercase tracking-tight" data-id="element-92">
          Sin preguntas · Sin formularios · Sin vueltas
        </p>

        <p className="text-sm md:text-base text-gray-300 mb-3 leading-relaxed" data-id="element-93">
          Usás el Kit en el aula. Si no es lo que esperabas, un mensaje con tu
          comprobante y te devolvemos el{' '}
          <span className="text-white font-bold" data-id="element-94">100%</span>.
        </p>

        <div className="bg-brand-card rounded-2xl border border-white/10 p-3" data-id="element-95">
          <p className="text-xs md:text-sm text-gray-400 leading-relaxed" data-id="element-96">
            <span className="text-white font-bold" data-id="element-97">
              Tasa de devoluciones: menos del 1%
            </span>
            <br data-id="element-98" />
            <span className="text-gray-500 italic text-[11px] md:text-xs" data-id="element-99">
              Porque el docente que lo usa, no lo devuelve.
            </span>
          </p>
        </div>
      </div>
    </section>;
}